import { createInertiaApp, router } from '@inertiajs/vue3';
import { InertiaToast } from '@laravel-inertia-toast/vue';
import '@erag/text-editor-vue/style.css';
import { createApp, h } from 'vue';
import { initializeTheme } from '@/composables/useAppearance';
import AppLayout from '@/layouts/AppLayout.vue';
import AuthLayout from '@/layouts/AuthLayout.vue';
import PublicLayout from '@/layouts/PublicLayout.vue';
import SettingsLayout from '@/layouts/settings/Layout.vue';
import pages from './pages';

const appName = import.meta.env.VITE_APP_NAME || 'KwikTalk';

createInertiaApp({
    title: (title) => (title ? `${title} - ${appName}` : appName),
    resolve: (name) => pages(name),
    layout: (name) => {
        switch (true) {
            case name.startsWith('public/'):
                return PublicLayout;
            case name === 'Onboarding':
                return null;
            case name.startsWith('auth/'):
                return AuthLayout;
            case name.startsWith('settings/'):
                return [AppLayout, SettingsLayout];
            default:
                return AppLayout;
        }
    },
    progress: {
        color: '#00BF63',
    },
    setup({ el, App, props, plugin }) {
        createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(InertiaToast, {
                duration: 5000,
                position: 'top-right',
                maxVisible: 5,
                propKey: 'toasts',
            })
            .mount(el);
    },
});

// This will set light / dark mode on page load...
initializeTheme();

// Umami auto-tracks the initial full page load. The SPA never reloads after
// that, so track every subsequent client-side navigation manually.
router.on('navigate', () => {
    window.umami?.track?.();
});
